/**
 * Sanitize folder or URL paths
 * @param {string} [value='']
 * @param {number} [length]
 * @returns {string}
 */
export default (value = '', length = 100) => {
	const stringValue = String(value);
	const charactersToSanitize = '[.:/\\\\]+'; // multiple escaping for string and regexp to prevent unterminated character error
	const trimRegExp = new RegExp(`^${charactersToSanitize}|${charactersToSanitize}$`, 'g');
	const replaceRegExp = new RegExp(charactersToSanitize, 'g');
	const sanitizedPath = stringValue.replace(trimRegExp, '').replace(replaceRegExp, '_'); // remove first and last occurrence of ".", ":", "/" or "\" and replace others with "_"
	if (sanitizedPath.length > length) {
		const substring = sanitizedPath.substring(0, length - 1);
		return `${substring}_`; // trim long paths
	} else {
		return sanitizedPath;
	}
};
